var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2092 54.1201C56.8511 58.2472 51.53 60.3063 47.7283 59.9631C42.5363 59.4938 36.8866 56.7395 32.5981 53.7065C26.2943 49.248 20.3894 42.352 16.9486 35.0336C14.5169 29.8623 13.9713 23.5031 17.5881 18.7894C18.9257 17.047 20.3748 16.1172 22.5455 16.0087C25.561 15.862 25.9834 17.5868 27.0188 20.2736C27.7903 22.2829 28.8199 24.3332 29.3949 26.4158C30.4714 30.3023 26.7079 30.4636 26.2327 33.6403C25.9394 35.6437 28.3652 38.3305 29.4623 39.759C31.5769 42.5411 34.1669 44.9274 37.1125 46.8076C38.7845 47.8606 41.4774 49.7584 43.3899 48.7112C46.335 47.098 46.0593 42.132 50.1748 43.8128C52.3073 44.681 54.3724 45.9335 56.4081 47.0305C59.5556 48.723 59.409 50.477 58.2092 54.1201C59.1068 51.3981 57.3116 56.8422 58.2092 54.1201Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallUs);
export default __webpack_public_path__ + "static/media/callUs.5437781c57e09b9fc1451c93353578f9.svg";
export { ForwardRef as ReactComponent };